// extracted by mini-css-extract-plugin
module.exports = {"data-table-select-filter":"transactionRequests_data-table-select-filter__3JRYA"};